<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 13C9 10.7909 10.7909 9 13 9H15V11H13C11.8954 11 11 11.8954 11 13V19C11 20.1046 11.8954 21 13 21H19C20.1046 21 21 20.1046 21 19V17H23V19C23 21.2091 21.2091 23 19 23H13C10.7909 23 9 21.2091 9 19V13Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18 7H23C24.1046 7 25 7.89543 25 9V14H23V9H18V7Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.4142 9L16 17.4142L14.5858 16L23 7.58579L24.4142 9Z"
        />
    </svg>
</template>
